import { mq, Paragraph } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledWhyPhishToolImageWrapper = styled.div.withConfig({ displayName: "StyledWhyPhishToolImageWrapper", componentId: "sc-1ctxys8" }) `
  position: relative;

  ${mq({
    width: ['100%', '45%', '50%'],
})}

  &::after {
    box-shadow: 18px 18px 36px 36px inset rgba(255, 255, 255, 0.6);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;
export const StyledWhyPhishToolImage = styled.img.withConfig({ displayName: "StyledWhyPhishToolImage", componentId: "sc-il6goy" }) `
  display: block;
  width: 100%;
`;
export const StyledWhyPhishToolContent = styled.div.withConfig({ displayName: "StyledWhyPhishToolContent", componentId: "sc-1xswf88" }) `
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${mq({
    width: ['100%', '55%', '40%'],
})}
`;
export const StyledWhyPhishToolIntro = styled.p.withConfig({ displayName: "StyledWhyPhishToolIntro", componentId: "sc-1makvh8" }) `
  ${(props) => props.theme.responsiveTypography.body.large};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  margin: 0 0 ${(props) => props.theme.spacers.x3};
`;
export const StyledContent = styled(Paragraph).withConfig({ displayName: "StyledContent", componentId: "sc-1covfuv" }) `
  white-space: pre-wrap;
`;
